import {
  IAlbumItem,
  IFormateDayDimensionDataItem,
  IFormateDataByDayResult,
} from '@remote/type/album'
import { requestAnimationFrame, delay } from '@remote/utils/base'
import {
  getAlbumFileList as getAlbumFileListApi,
} from '@remote/api/adapter/shell-mqtt'
import { downloadHeziFile } from '@remote/store/hezi-file'
import { pathJoin } from '@remote/utils/file-helper'

export const calcDaysOffFromToday = (date: Date): number => {
  const targetTimestamp = date.getTime()
  const todayMinTimestamp = new Date(new Date().toDateString()).getTime()
  const diff = targetTimestamp - todayMinTimestamp
  return diff > 0 ? 0 : Math.ceil((Math.abs(diff)) / (24 * 60 * 60 * 1000))
}

export const formateDataByDay = (data: Array<IAlbumItem>): IFormateDayDimensionDataItem[] => {
  const getDate = (dateStr: number): string => {
    const date = new Date(dateStr)
    return `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}`
  }

  const getDisplayDate = (dateStr: string): string => {
    const date = new Date(dateStr.replace(/_/g, '/'))
    // const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    // return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${days[date.getDay()]}`
    const diffDay = calcDaysOffFromToday(date)
    const specialDaysMap = ['今天', '昨天']

    if (diffDay < 2) return `${specialDaysMap[diffDay]}`
    if (diffDay <= 7) return `${date.getMonth() + 1}月${date.getDate()}日`
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
  }

  const dayDimensionData = data.reduce((result: IFormateDataByDayResult, item: IAlbumItem) => {
    const id = getDate(item.time_create * 1000)
    // // eslint-disable-next-line no-param-reassign
    // if (!item.width) item.width = 170
    // // eslint-disable-next-line no-param-reassign
    // if (!item.height) item.height = 170

    if (result[id]) {
      result[id].push(item)
    } else {
      result[id] = [item]
    }
    return result
  }, {})

  return Object.keys(dayDimensionData).reduce((result: IFormateDayDimensionDataItem[], key: string) => {
    result.push({
      id: key,
      date: getDisplayDate(key),
      imageList: [...dayDimensionData[key]],
    })

    return result
  }, [])
}

// 获取指定目录下全部照片
export async function getSubPathAlbumAllFileList (
  subPath: string,
):Promise<[number, IAlbumItem[]]> {

  let result: IAlbumItem[] = []
  let errMsg = 0
  let pageToken = ''

  const getData = async (resolve) => {
    const params = {
      platform: 'pc',
      sub_path: subPath,
      media: 0,
      page_size: 100,
      page_token: pageToken,
    }

    const res = await getAlbumFileListApi(params)
    let list: IAlbumItem[] = []
    console.log('res', res)
    if (res.ret === 0 && res.result?.length) {
      list = res.result
      pageToken = res.page_token
      result = result.concat(list)
      if (list.length >= params.page_size && pageToken) {
        requestAnimationFrame(getData.bind(null, resolve))
      } else {
        resolve()
      }
    } else {
      errMsg = res.ret
      resolve()
    }
  }

  const loop = () => {
    return new Promise((resolve) => {
      getData(resolve)
    })
  }

  await loop()
  return [errMsg, result]
}

// 下载相册照片
export async function downloadPhoto (photo: IAlbumItem, subPath?:string, noXHR?:boolean) {
  const TenMB = 10 * 1024 * 1024
  const byXHR = typeof noXHR !== void 0 ? false : photo.size < TenMB
  await downloadHeziFile({
    path: pathJoin(subPath, photo.rel_path),
    md5sum: photo.md5sum,
    name: photo.name,
    size: String(photo.size),
    hash: '',
  }, byXHR)
  if (!byXHR && !noXHR) await delay(1000 * 3)
}